export default __webpack_public_path__ + "d1c8e828f03dbc94c72d418d75be6f88.svg";